import { EntityCommand, EntityCommandPropertyValues, EntityCommandTypeEnum, IEntityCommand } from "@seriously-rad/seriouslyrad-framework-core/EntityCommand";
import { EntityCommandInformation } from "@seriously-rad/seriouslyrad-framework-core/EntityCommandInformation";
import { PartialNullable } from "@seriously-rad/seriouslyrad-framework-core/Extensions";
import { Property } from "@seriously-rad/seriouslyrad-framework-core/RadObject";
import { PermissionEvaluator } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/SeriouslyRAD.Framework.Data.Entities/Evaluation/Evaluators/PermissionEvaluator";
import { NAMESPACE } from "./_Namespace";

export type EntityCommandProcessInstanceItemViewProcessInstancePropertyValues =
    EntityCommandPropertyValues
    & {
    };

export type EntityCommandProcessInstanceItemViewProcessInstanceProperties = {
    [name in keyof EntityCommandProcessInstanceItemViewProcessInstancePropertyValues]: Property<EntityCommandProcessInstanceItemViewProcessInstancePropertyValues[name]>
};

export interface IEntityCommandProcessInstanceItemViewProcessInstance extends IEntityCommand, EntityCommandProcessInstanceItemViewProcessInstanceProperties
{
}

export class EntityCommandProcessInstanceItemViewProcessInstance extends EntityCommand implements IEntityCommandProcessInstanceItemViewProcessInstance
{
    // #region Static

    public static override classNamespace = NAMESPACE + "EntityCommandProcessInstanceItemViewProcessInstance";
    public static override className = "EntityCommandProcessInstanceItemViewProcessInstance";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<EntityCommandProcessInstanceItemViewProcessInstancePropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                description: "View Process Instance",
                entityName: "ProcessInstanceItem",
                key: "VIEW_PROCESS",
                permission: PermissionEvaluator.permissionLevels.read,
                type: EntityCommandTypeEnum.entity,
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Constructor

    constructor(propertyValues?: PartialNullable<EntityCommandProcessInstanceItemViewProcessInstancePropertyValues>)
    {
        super(propertyValues);
    }

    // #endregion

    // #region Overrides

    protected override async _executeAsync(entityCommandInformation: EntityCommandInformation, value?: any)
    {
        await super._executeAsync(entityCommandInformation, value);

        const
            recordId = entityCommandInformation.getRecordId();

        if (!recordId)
            return;

        const
            ViewProcessDialog = (await import("../Ui/Dialogs/ViewProcessDialog")).ViewProcessDialog;

        ViewProcessDialog.instance
            .openAsync({
                processInstanceItemId: recordId
            });
    }

    // #endregion

    // #endregion
}

